const TOKEN = 'token'


let memoryLocalStorage = {}
const wrapperLocalStorage = {
  setItem: function (name, value) {
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem(name, value)
      } catch (ex) {
        console.log('localstore dont exist')
      } finally {
        memoryLocalStorage[name] = value
      }
    } else {
      memoryLocalStorage[name] = value
    }
  },
  getItem: function (name) {
    let item = {}
    if (typeof localStorage !== 'undefined') {
      try {
        item = localStorage.getItem(name)
        // fix iphone 5s in private mode, localstorage has identifier but return null with all request
        if (item === null) {
          item = memoryLocalStorage[name]
        }
      } catch (ex) {
        console.log('localstore dont exist')
        item = memoryLocalStorage[name]
      } finally {
        return item
      }
    } else {
      return memoryLocalStorage[name]
    }
  },
  removeItem: function (name) {
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.removeItem(name)
      } catch (ex) {
        console.log('localstore dont exist')
      } finally {
        memoryLocalStorage[name] = null
      }
    } else {
      memoryLocalStorage[name] = null
    }
  },
  clear: function () {
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.clear()
      } catch (ex) {
        console.log('localstore dont exist')
      } finally {
        memoryLocalStorage = {}
      }
    } else {
      memoryLocalStorage = {}
    }
  }
}

export default {
  getToken: function () {
    if (typeof localStorage !== 'undefined') {
      var token = wrapperLocalStorage.getItem(TOKEN)
      if (token) {
        return token;
      }
      return null
    }
  },

  getLocalVersion: function () {
    return wrapperLocalStorage.getItem('localStoreVersion')
  },
  
  clearAll: function () {
    wrapperLocalStorage.clear()
  }
}
